import { Box, Stack, Text } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useThemeStore } from "../../../../stores/ThemeStore";

const Image = ({ ...props }) => {
  const theme = useThemeStore((s) => s.theme);
  const mainColor = theme.colors.primary[6];
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 904.51179 587.86116"
    >
      <path
        d="M1030.78225,515.09691H998.97854a4.50052,4.50052,0,0,1-3.53467-1.70263,4.4081,4.4081,0,0,1-.86279-3.74561,86.5354,86.5354,0,0,0-.41992-40.00439,4.471,4.471,0,0,1,2.42236-5.13086c13.28418-6.21778,25.4834-6.05567,36.25684.48047a4.52651,4.52651,0,0,1,2.14306,3.15136,141.55237,141.55237,0,0,1,.25928,43.08008A4.49087,4.49087,0,0,1,1030.78225,515.09691Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M1030.2993,494.26144h-24.31753a2.28111,2.28111,0,0,1,0-4.56221h24.31753a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M1030.2993,486.26144h-24.31753a2.28111,2.28111,0,0,1,0-4.56221h24.31753a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <circle cx="246.14815" cy="186.83946" r="169" fill="#f2f2f2" />
      <circle cx="442.14815" cy="318.83946" r="32" fill="#f2f2f2" />
      <circle cx="603.14815" cy="409.83946" r="13" fill="#f2f2f2" />
      <path
        d="M851.26623,617.03957c-5.48227-41.89209-31.72983-83.03451-71.80138-96.42224a194.65881,194.65881,0,0,1,.84589,133.64365c-6.03764,16.65872-14.48752,34.55857-8.601,51.2714,3.66252,10.3992,12.51019,18.31678,22.375,23.23971,9.86539,4.92293,20.7937,7.22943,31.58512,9.48926l2.13212,1.74051C844.66219,701.26258,856.74849,658.93165,851.26623,617.03957Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#f2f2f2"
      />
      <path
        d="M779.07315,521.41262A166.38078,166.38078,0,0,1,821.03373,614.785c.77448,7.452.91159,15.0788-.67137,22.439A41.09416,41.09416,0,0,1,810.264,656.34932c-4.57415,5.09072-9.84254,9.76827-13.09956,15.88225-3.43308,6.44445-3.51986,13.74226-1.09777,20.54873,2.96348,8.32791,8.74259,15.09434,14.624,21.51494,6.53021,7.12885,13.426,14.43,16.24318,23.91839.34134,1.14965,2.10524.55278,1.76442-.59513-4.9014-16.50811-21.01635-25.7997-28.76822-40.647-3.61716-6.928-5.1684-14.98807-1.866-22.34688,2.88776-6.435,8.31644-11.26314,12.99242-16.37757,4.90986-5.37024,8.66318-11.25191,10.5708-18.33254,1.95139-7.24308,2.11217-14.89135,1.53161-22.33044a161.41915,161.41915,0,0,0-12.10288-48.97743,169.33088,169.33088,0,0,0-30.75964-48.59845c-.80186-.88642-2.01977.52378-1.22315,1.40441Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M820.46039,603.51974a24.96242,24.96242,0,0,0,18.83354-26.27016c-.10252-1.19368-1.96226-1.09045-1.8596.10482a23.11466,23.11466,0,0,1-17.56907,24.40092c-1.16391.2846-.56212,2.04739.59513,1.76442Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M812.92321,654.07358a48.11307,48.11307,0,0,1-21.6623-27.57147c-.3454-1.1484-2.1094-.55188-1.76442.59513a50.04481,50.04481,0,0,0,22.5999,28.64479c1.03645.60587,1.85764-1.06587.82682-1.66845Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M801.9328,552.54666a14.12991,14.12991,0,0,1-13.39448-.594c-1.02826-.6187-1.84838,1.05378-.82682,1.66845a15.83373,15.83373,0,0,0,14.81643.69.96232.96232,0,0,0,.58464-1.17978.93574.93574,0,0,0-1.17977-.58464Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M658.06671,596.28153c.63108.40459,1.26215.80918,1.89409,1.22949a186.08338,186.08338,0,0,1,23.91132,18.42308c.585.51491,1.17,1.04555,1.739,1.57619a196.17349,196.17349,0,0,1,42.97728,58.04679,190.50774,190.50774,0,0,1,10.608,26.93206c3.93234,12.75189,7.18139,26.89106,14.87036,37.293a32.68383,32.68383,0,0,0,2.56618,3.12676l68.88025-.44095c.156-.07956.31294-.14349.46974-.22305l2.751.10814c-.11361-.48646-.24191-.98856-.35553-1.475-.06473-.28246-.14481-.56483-.20954-.84729-.048-.18827-.0968-.37664-.12937-.54929-.01575-.06272-.03227-.12545-.04791-.17254-.03257-.17264-.08115-.32955-.11362-.48646q-1.06408-4.21287-2.19109-8.42543c-.0001-.01573-.0001-.01573-.01555-.03136-5.77943-21.38383-13.39485-42.473-23.96911-61.73592-.31834-.57945-.636-1.17462-.9858-1.75387a181.78808,181.78808,0,0,0-16.487-24.66278,160.709,160.709,0,0,0-10.78057-12.17367,133.64063,133.64063,0,0,0-33.60217-24.8361c-24.78827-12.88552-53.42164-17.69987-79.77278-9.56319C659.4,595.84873,658.74057,596.05717,658.06671,596.28153Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#f2f2f2"
      />
      <path
        d="M658.22716,597.15477A166.38073,166.38073,0,0,1,747.947,646.44419c5.105,5.48369,9.80633,11.49074,12.97379,18.32053a41.094,41.094,0,0,1,3.45176,21.35041c-.58724,6.81862-1.97754,13.72531-.89706,20.56793,1.13889,7.21249,5.46339,13.09162,11.49525,17.06795,7.38016,4.86515,16.06831,6.78834,24.63,8.3738,9.50606,1.76035,19.40779,3.4382,27.36979,9.318.96471.71242,2.01373-.82614,1.05048-1.53748-13.85252-10.22982-32.31358-7.94632-47.4421-15.13388-7.05924-3.35385-13.15053-8.85541-14.9443-16.71925-1.56858-6.87658-.141-14,.51329-20.8989.687-7.24391.14264-14.19986-2.59726-21.00186-2.80276-6.95807-7.27917-13.16158-12.22157-18.75174a161.41917,161.41917,0,0,0-39.15126-31.819A169.33138,169.33138,0,0,0,658.35823,595.297c-1.17392-.225-1.29732,1.63425-.13107,1.85777Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M740.70672,637.79473a24.96243,24.96243,0,0,0-.77892-32.31435c-.80054-.89136-2.22328.31075-1.42168,1.2033a23.11466,23.11466,0,0,1,.66312,30.06056c-.758.928.78385,1.97317,1.53748,1.05049Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M765.1256,682.697a48.11305,48.11305,0,0,1-33.89606-8.97208c-.96719-.709-2.01651.82936-1.05048,1.53748A50.04483,50.04483,0,0,0,765.47,684.527c1.19232-.14027.84149-1.96947-.34436-1.83Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M695.22416,608.25046a14.12991,14.12991,0,0,1-11.05238,7.59012c-1.1935.12509-.84138,1.95424.34436,1.83a15.83372,15.83372,0,0,0,12.2455-8.36961.96232.96232,0,0,0-.2435-1.294.93575.93575,0,0,0-1.294.2435Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M988.43489,453.31889l-9.315-90.16375-2.45863-37.10843,26.07234-4.7144s3.90423,25.5103,7.31974,40.48087c3.37052,14.77276-4.49018,89.52617-4.69845,91.49765a12.68492,12.68492,0,1,1-16.92.00806Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#ffb8b8"
      />
      <polygon
        points="734.148 574.092 720.884 574.092 714.574 522.932 734.15 522.933 734.148 574.092"
        fill="#ffb6b6"
      />
      <path
        d="M885.27444,743.01889l-42.76752-.00158v-.54094a16.64719,16.64719,0,0,1,16.64631-16.646h.00106l7.81205-5.92664,14.57555,5.92754,3.73334.00015Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#2f2e41"
      />
      <polygon
        points="851.045 574.092 837.782 574.092 831.472 522.932 851.048 522.933 851.045 574.092"
        fill="#ffb6b6"
      />
      <path
        d="M1002.17211,743.01889l-42.76752-.00158v-.54094a16.64719,16.64719,0,0,1,16.64631-16.646h.00106l7.81205-5.92664,14.57555,5.92754,3.73334.00015Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#2f2e41"
      />
      <path
        d="M978.61621,456.35057,989.772,562.33128s14.851,106.11694,12.062,120.759.69723,16.7338.69723,16.7338l-25.44814-1.81236s.69723-9.06416-3.48624-13.24757-2.09168-16.73381-2.09168-16.73381L922.13969,495.3961l-29.98137,90.64141s-4.8807,99.70557-5.57792,101.1-2.789,20.22-2.789,20.22h-25.798s3.48619-11.15584-1.3945-14.64208-9.06416-.69722-4.8807-6.97242,5.57792-13.94485,4.18347-17.431-1.39451-17.431-1.39451-17.431,2.09174-188.25519,13.94485-194.53039S978.61621,456.35057,978.61621,456.35057Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#2f2e41"
      />
      <circle cx="778.04043" cy="58.25857" r="27.4387" fill="#ffb8b8" />
      <path
        d="M1007.129,335.7166l-26.98618,9.67809-8.219,2.9451-5.999-76.62693,20.58857,10.91955a.43133.43133,0,0,1,.0906.09049,55.71552,55.71552,0,0,1,8.8625,13.14873C1006.75738,318.82533,1007.129,335.7166,1007.129,335.7166Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#3f3d56"
      />
      <path
        d="M821.22462,446.84542s27.42772-85.21874,27.9073-86.24066c3.59241-27.28049,13.92471-39.31418,15.47362-38.00777l26.66794,9.23874s-7.93233,25.119-13.303,40.03927c-5.13192,14.25688-40.278,80.07986-41.265,81.79912a12.68491,12.68491,0,1,1-15.48083-6.8287Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#ffb8b8"
      />
      <path
        d="M904.0841,276.64775s-23.08916-11.31585-32.04437,10.909c-5.86461,14.98839-8.64183,21.52622-12.55758,37.1375,0,0,23.53514,3.531,31.08183,16.83072Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#3f3d56"
      />
      <path
        d="M988.09909,467.90158c-53.13861,10.97387-123.55809-7.89282-123.55809-7.89282L883.32616,378.579l-6.67857-85.21753c-.81558-10.42111,5.12-20.18969,14.35392-23.65126l12.75006-4.77561,10.53881-15.088,30.10339.98771,12.03414,15.84007,9.49679,5.03843,20.58857,10.91955.0906.04525v.04524l-6.4611,62.67179-3.89652,37.78781s11.8347,42.49991,9.40608,48.13646c-2.42851,5.62736-.317,2.90881.2719,5.91729.589,3.0086,2.39234,3.19886,2.66413,9.12533C988.86933,452.279,988.09909,467.90158,988.09909,467.90158Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#3f3d56"
      />
      <path
        d="M955.55005,204.55727c-2.16834-2.13913,1.09578-7.80233.4792-10.78526-.70685-3.42-4.4755-3.52009-5.3745-6.89472-.96724-3.63026-4.83511-5.60656-8.41162-6.7571a54.391,54.391,0,0,0-28.34666-1.29833,108.2013,108.2013,0,0,0-12.26345,3.77772c-2.76789.9741-.09868-1.67664-2.86645-.70253a4.34484,4.34484,0,0,0-2.59521,1.72188c-.49756.9408.17345,2.44543,1.22034,2.25484q-5.06841,2.2352-10.13705,4.47041,2.84267,2.97773,5.68533,5.95567c-2.694-.7668-5.5663,2.44533-4.50415,5.03711a5.69338,5.69338,0,0,0,4.35648,3.01589c3.04365.59225.73505,3.4889,3.83535,3.43248s24.71949-6.41153,26.22666-3.70172c1.07322,1.92962.95519,4.48556,2.48758,6.07537,1.9606,2.03393,5.3839,1.29013,7.87944-.03408,2.49544-1.32409,5.02627-3.144,7.83353-2.82651,2.93072.33141,5.14728,5.74727,5.86907,8.60708.72189,2.85981.26592,5.86885-.19347,8.78242-.60331,3.82639-6.64373,7.65267-7.247,11.47895,6.704,1.854,13.89541-4.04486,16.54582-14.30314C955.7652,215.379,960.17012,209.11551,955.55005,204.55727Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#2f2e41"
      />
      <path
        d="M528.99139,560.91318c-80.77392.00391-151.05273-60.252-161.43506-142.4375l1.98438-.251c10.2539,81.1709,79.67676,140.6836,159.45215,140.68848a161.36039,161.36039,0,0,0,20.27343-1.2793c87.98584-11.11523,150.52442-91.73926,139.40918-179.72509l1.98438-.251c11.25342,89.07959-52.063,170.70752-141.14258,181.96045A163.74439,163.74439,0,0,1,528.99139,560.91318Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#3f3d56"
      />
      <path
        d="M533.32878,594.36151H501.52507a4.50049,4.50049,0,0,1-3.53466-1.70263,4.40807,4.40807,0,0,1-.8628-3.74561,86.51558,86.51558,0,0,0-.52-40.40088,4.47676,4.47676,0,0,1,1.95117-4.87353c11.00245-6.81592,22.98291-6.603,36.62793.65185a4.55074,4.55074,0,0,1,2.36817,3.27491,141.562,141.562,0,0,1,.23437,42.92431A4.49087,4.49087,0,0,1,533.32878,594.36151Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M388.32878,424.36151H356.52507a4.50049,4.50049,0,0,1-3.53466-1.70263,4.40807,4.40807,0,0,1-.8628-3.74561,86.49,86.49,0,0,0-.55517-40.53613,4.509,4.509,0,0,1,1.74951-4.73828c16.35351-11.76172,29.23242-11.42041,38.27929,1.01611a4.51917,4.51917,0,0,1,.79151,1.90967,141.54,141.54,0,0,1,.39648,43.92529A4.49087,4.49087,0,0,1,388.32878,424.36151Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#ccc"
      />
      <path
        d="M518.46882,564.5127H507.5283a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.2811,2.2811,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M531.84583,573.526H507.5283a2.28111,2.28111,0,0,1,0-4.56221h24.31753a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M378.46882,392.5127H367.5283a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M378.46882,400.5127H367.5283a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M378.46882,408.5127H367.5283a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M816.37043,461.93466H714.70537a10.28839,10.28839,0,0,1-10.27672-10.27677V389.04176A10.2884,10.2884,0,0,1,714.70537,378.765H816.37043a10.28841,10.28841,0,0,1,10.27678,10.27678v62.61613A10.28841,10.28841,0,0,1,816.37043,461.93466Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#e6e6e6"
      />
      <path
        d="M775.97729,453.86927H721.8518a9.63563,9.63563,0,0,1-9.625-9.62451v-47.79a9.63563,9.63563,0,0,1,9.625-9.62451h87.37256a9.63521,9.63521,0,0,1,9.62451,9.62451v14.54346A42.9198,42.9198,0,0,1,775.97729,453.86927Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M800.50816,412.999H730.56764a2.281,2.281,0,1,1,0-4.562h69.94052a2.281,2.281,0,1,1,0,4.562Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M741.50816,422.0123H730.56764a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M760.88517,431.02563H730.56764a2.2811,2.2811,0,0,1,0-4.5622h30.31753a2.2811,2.2811,0,1,1,0,4.5622Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <circle cx="553.1367" cy="221.44848" r="21.50617" fill="#3f3d56" />
      <path
        d="M457.43074,213.91906a56.086,56.086,0,1,1,110.05652,21.68253l-1.96288-.38651a54.08546,54.08546,0,1,0-106.13077-20.90951Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#3f3d56"
      />
      <path
        d="M478.72848,249.30339,446.952,250.61952a4.50052,4.50052,0,0,1-3.6021-1.55491,4.408,4.408,0,0,1-1.01706-3.70669,86.53527,86.53527,0,0,0-2.075-39.95275,4.47106,4.47106,0,0,1,2.20795-5.22671c13.0155-6.76218,25.211-7.10505,36.24566-1.02035a4.52655,4.52655,0,0,1,2.27165,3.06,141.5524,141.5524,0,0,1,2.04182,43.03244A4.49087,4.49087,0,0,1,478.72848,249.30339Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M477.38371,228.50575,453.087,229.51207a2.2811,2.2811,0,1,1-.1888-4.55829l24.2967-1.00633a2.2811,2.2811,0,0,1,.18879,4.5583Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M477.05265,220.5126l-24.2967,1.00633a2.2811,2.2811,0,0,1-.18879-4.5583l24.2967-1.00633a2.2811,2.2811,0,0,1,.18879,4.5583Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M686.68589,239.2391H585.02083a10.28839,10.28839,0,0,1-10.27672-10.27678V166.3462a10.28839,10.28839,0,0,1,10.27672-10.27678H686.68589a10.28841,10.28841,0,0,1,10.27678,10.27678v62.61613A10.28841,10.28841,0,0,1,686.68589,239.2391Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#e6e6e6"
      />
      <path
        d="M646.29275,231.17371H592.16726a9.63563,9.63563,0,0,1-9.625-9.62451v-47.79a9.63563,9.63563,0,0,1,9.625-9.62451h87.37256a9.63521,9.63521,0,0,1,9.62451,9.62451v14.54346A42.91981,42.91981,0,0,1,646.29275,231.17371Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M670.82362,190.3034H600.8831a2.281,2.281,0,1,1,0-4.562h69.94052a2.281,2.281,0,1,1,0,4.562Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M611.82362,199.31674H600.8831a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M631.20063,208.33007H600.8831a2.2811,2.2811,0,0,1,0-4.56221h30.31753a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <circle
        cx="568.56211"
        cy="238.72495"
        r="21.50616"
        transform="translate(-82.08946 439.49802) rotate(-58.13426)"
        fill="#3f3d56"
      />
      <path
        d="M1051.33655,743.93058H755.86529a.91934.91934,0,0,1,0-1.83868h295.47126a.91934.91934,0,1,1,0,1.83868Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#ccc"
      />
      <path
        d="M282.07245,406.49912A94.03112,94.03112,0,0,1,457.9704,339.961l-1.8711.708a92.03055,92.03055,0,1,0-172.15576,65.12207Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#3f3d56"
      />
      <path
        d="M364.32878,313.36151H332.52507a4.50049,4.50049,0,0,1-3.53466-1.70263,4.40807,4.40807,0,0,1-.8628-3.74561,86.51423,86.51423,0,0,0-.49707-40.30908,4.4618,4.4618,0,0,1,2.05762-4.9375c11.52051-6.70605,23.82324-6.50147,36.56543.60986a4.5125,4.5125,0,0,1,2.293,3.23438,141.56107,141.56107,0,0,1,.24267,42.979A4.49087,4.49087,0,0,1,364.32878,313.36151Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M349.46882,282.5127H338.5283a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M362.84583,291.526H338.5283a2.2811,2.2811,0,0,1,0-4.56221h24.31753a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M259.68589,405.2391H158.02083a10.28839,10.28839,0,0,1-10.27672-10.27678V332.3462a10.28839,10.28839,0,0,1,10.27672-10.27678H259.68589a10.28841,10.28841,0,0,1,10.27678,10.27678v62.61613A10.28841,10.28841,0,0,1,259.68589,405.2391Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#e6e6e6"
      />
      <path
        d="M219.29275,397.17371H165.16726a9.63563,9.63563,0,0,1-9.625-9.62451v-47.79a9.63563,9.63563,0,0,1,9.625-9.62451h87.37256a9.63521,9.63521,0,0,1,9.62451,9.62451v14.54346A42.91981,42.91981,0,0,1,219.29275,397.17371Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M243.82362,356.3034H173.8831a2.281,2.281,0,1,1,0-4.562h69.94052a2.281,2.281,0,1,1,0,4.562Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M184.82362,365.31674H173.8831a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <path
        d="M204.20063,374.33007H173.8831a2.28111,2.28111,0,0,1,0-4.56221h30.31753a2.2811,2.2811,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill={mainColor}
      />
      <circle
        cx="281.56211"
        cy="402.72495"
        r="21.50616"
        transform="translate(-356.85653 273.17189) rotate(-58.13426)"
        fill="#3f3d56"
      />
      <path
        d="M473.32878,373.36151H441.52507a4.50049,4.50049,0,0,1-3.53466-1.70263,4.40807,4.40807,0,0,1-.8628-3.74561,86.52041,86.52041,0,0,0-.47949-40.24023,4.4894,4.4894,0,0,1,2.124-4.978c15.44971-8.84375,27.68311-8.59961,37.39991.74658a4.4406,4.4406,0,0,1,1.2788,2.47608,141.55617,141.55617,0,0,1,.33838,43.57226A4.49087,4.49087,0,0,1,473.32878,373.36151Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#ff6584"
      />
      <path
        d="M460.46882,343.5127H449.5283a2.28111,2.28111,0,0,1,0-4.56221h10.94052a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
      <path
        d="M473.84583,352.526H449.5283a2.2811,2.2811,0,0,1,0-4.56221h24.31753a2.28111,2.28111,0,0,1,0,4.56221Z"
        transform="translate(-147.74411 -156.06942)"
        fill="#fff"
      />
    </svg>
  );
};

const Step4 = () => {
  const lang = useLanguage((s) => s.language);
  return (
    <Stack pos={"relative"} style={{ overflow: "hidden" }} w={500}>
      <Text fw={600} fz={"xl"}>
        {lang.home.discover.step4.text1}
      </Text>

      <Box w={350} mx={"auto"} mt={"xs"}>
        <Image width="100%" />
      </Box>
    </Stack>
  );
};

export default Step4;
